<div class="header">
  <h1
    class="documents-header-text"
    [ngClass]="{
      'changed-label':
        changes.entityAttributes.includes(jobseekerEnum.Attachment) && isEdited
    }"
  >
    {{ 'label.UploadedDocuments' | translate }}
  </h1>
</div>
<div class="container">
  <div
    class="documents"
    [ngClass]="{
      'changed-label':
        checkAddedDocuments(document.jobseekerDocumentId) && isEdited
    }"
    *ngFor="let document of documents"
  >
    <div class="document">
      <a
        *ngIf="document?.filename"
        [href]="document.filename"
        class="attachment"
        target="_blank"
      >
        <span style="font-weight: 500; color: #819dcd"
          >{{ document.name }}
        </span>
      </a>
      <span *ngIf="document.label" class="description">{{
        document.label
      }}</span>
    </div>
    <app-reject-dialog
      *ngIf="checkAddedDocuments(document.jobseekerDocumentId) && isEdited"
      [id]="document.objectId"
      (setDictionary)="reject($event)"
    ></app-reject-dialog>
  </div>
  <div
    class="deleted-document"
    *ngIf="
      changes.jobseekerDocumentChanges?.removedDocuments?.length &&
      changes.jobseekerDocumentChanges?.removedDocuments?.length > 0 &&
      isEdited
    "
  >
    <div
      class="documents deleted-label"
      *ngFor="let document of changes.jobseekerDocumentChanges.removedDocuments"
    >
      <div class="document">
        <a
          *ngIf="document?.filename"
          [href]="document.filename"
          class="attachment"
        >
          <span style="font-weight: 500; color: #819dcd">{{
            document.documentType.name
          }}</span>
        </a>
        <span *ngIf="document.label" class="description">{{
          document.label
        }}</span>
      </div>
    </div>
  </div>
</div>
